import StandardCardContent from '@ifca-root/react-component/src/components/CardList/StandardCardContent';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import { useGetTaxSchemeListingQuery } from 'generated/graphql';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const PaymentCodeDetail = ({ mode }: { mode: string }) => {
  useEffect(() => {
    console.log('BankTTDetail');
  }, []);
  let history = useHistory();
  let location = useLocation();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));

      const {
        data: { getTaxSchemeListing } = { getTaxSchemeListing: [] },
        loading: taxSchemeListingLoading,
        refetch,
      } = useGetTaxSchemeListingQuery({
        fetchPolicy: 'network-only',
        variables: {
          accountID: user?.accountID,
        },
      });

    const localInfo: any = location.state;

  return (
    <>
      <MainHeader
         onClick={() =>
          history.push(mode === 'Bank TT' ? '/menu/outlet-app/account-journals/account-mapping/bank-tt'
              : '/menu/outlet-app/account-journals/account-mapping/voucher')
        }
        mainBtn="back"
        smTitle="Outlet App"
        title={user?.companyName}
        routeSegments={[
          { name: 'Account Mapping' },
          { name: mode === 'Bank TT' ? 'Bank TT' : 'Voucher', current: true },
        ]}
        rightRouteSegments={[
          {
            name: 'Details',
            current: true,
          },
        ]}
      />
      <ContentWrapper>
        <StandardCardContent>
          <div className="content-wrap full">
            <div className="desc">Code</div>
            <div className="xsTitle">
              {localInfo?.code || 'N/A'}
          </div>
          </div>
          <div className="content-wrap full">
            <div className="desc">Name</div>
            <div className="xsTitle">{localInfo?.name}</div>
          </div>
          {/* <div className="content-wrap full">
            <div className="desc">Tax Scheme</div>
            <div className="xsTitle">{getTaxSchemeListing?.find(x => x?.id === localInfo.taxSchemeID)?.name || 'N/A'}</div>
          </div> */}
        </StandardCardContent>
      </ContentWrapper>
    </>
  );
};
